import React from 'react';
import { Spin } from 'antd';
import styles from './Loader.module.css';

export default function Loader() {
  return (
    <>
      <div className={`d-flex align-items-center justify-content-center ${styles.loader_container}`}>
        <div className="row d-flex justify-content-center">
          <div className="col-12 mb-4 pt-1">
            <div className="p-2 text-center mx-auto w-25">
              <div>
                <Spin size="large" />
              </div>
            </div>
          </div>
          {/* loading text here */}
        </div>
      </div>
    </>
  );
}
